import React from 'react';
import BoxSecondaryUnderline from './BoxSecondaryUnderline';

export default function TitleAndData(props) {
  const titleClassName = props.smallTitle
    ? 'title-and-data__small-title'
    : 'title-and-data__title';
  const dataClassName = props.smallData
    ? 'title-and-data__small-data'
    : 'title-and-data__data';
  return (
    <BoxSecondaryUnderline tenant={props.tenant}>
      <div id="title-and-data" className="title-and-data">
        <div>
          <p className={titleClassName}>{props.title}</p>
          <div
            className="title-and-data__secondary-color-bar"
            style={{ backgroundColor: props.tenant.secondary }}
          />
        </div>
        <p className={dataClassName}>{props.data}</p>
      </div>
    </BoxSecondaryUnderline>
  );
}
